export const environment = {
    production: true,
    baseURL: "https://v2-dex.backend.perpx.ai",
    // baseURL: "http://localhost:8091/",
    // baseURL: "https://betabackend.bru.finance/",
};
